'use client';

import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useColorMode } from './ColorModeProvider';

export default function DarkModeToggle() {
  const { mode, toggleColorMode } = useColorMode();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Before mount: same DOM structure, invisible, so layout is stable
  const isDark = mounted && mode === 'dark';

  return (
    <Tooltip title={mounted ? (isDark ? 'Switch to light mode' : 'Switch to dark mode') : ''}>
      <IconButton
        onClick={mounted ? toggleColorMode : undefined}
        color="inherit"
        size="small"
        aria-label="toggle dark mode"
        sx={{ visibility: mounted ? 'visible' : 'hidden' }}
      >
        {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
